import { useState } from 'react';

export const usePayment = () => {
  const [isInPaymentProcess, setIsInPaymentProcess] = useState(false);
  const [isExpressPaymentInProcess, setIsExpressPaymentInProcess] = useState(false);
  const [isFormValid, setIsFormValid] = useState(true);
  return {
    isInPaymentProcess,
    setIsInPaymentProcess,
    isExpressPaymentInProcess,
    setIsExpressPaymentInProcess,
    isFormValid,
    setIsFormValid,
  };
};
